import React, { useState, useEffect } from 'react';
import { Spinner } from "@chakra-ui/react";
import axios from 'axios';
import { toast } from "react-toastify";

const EditUserModal = ({ user, onClose, onUserUpdated }) => {
  const [editedUser, setEditedUser] = useState(user);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setEditedUser(user); // Reset the edited user if 'user' prop changes
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedUser({ ...editedUser, [name]: value });
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await axios.put(`https://online-bank-qulz.onrender.com/api/users/${editedUser._id}`, editedUser);

      onUserUpdated(); // Refresh the user list after saving
      onClose(); // Close the modal after saving
      setIsLoading(false);
      const TOAST_ID = "success-toast";

      if (!toast.isActive(TOAST_ID)) {
        toast.success("Account updated successfully!.", {
          className: "custom-toast",
        });
      }
    } catch (error) {
      console.error('Error updating user:', error);
      setIsLoading(false);
      const TOAST_ID = "failed-toast";

      if (!toast.isActive(TOAST_ID)) {
        toast.error("Account failed to update!.", {
          className: "custom-toast",
        });
      }
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h2>Edit User</h2>
        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>First Name:</label>
            <input
              type="text"
              name="firstName"
              value={editedUser.firstName}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Last Name:</label>
            <input
              type="text"
              name="lastName"
              value={editedUser.lastName}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Email:</label>
            <input
              type="email"
              name="email"
              value={editedUser.email}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Occupation:</label>
            <input
              type="text"
              name="occupation"
              value={editedUser.occupation}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Account Number:</label>
            <input
              type="text"
              name="accountNumber"
              value={editedUser.accountNumber}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>Account Type:</label>
            <select
              name="accountType"
              value={editedUser.accountType}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="">Select Account Type</option>
              <option value="Savings Account">Savings</option>
              <option value="Current Account">Current</option>
            </select>
          </div>


          <div style={inputContainerStyle}>
            <label style={labelStyle}>Country:</label>
            <input
              type="text"
              name="country"
              value={editedUser.country}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Deposit:</label>
            <input
              type="number"
              name="deposit"
              value={editedUser.deposit}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>Balance:</label>
            <input
              type="number"
              name="balance"
              value={editedUser.balance}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>ETH Balance (In ETH):</label>
            <input
              type="number"
              name="ethBalance"
              value={editedUser.ethBalance}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Earnings:</label>
            <input
              type="number"
              name="earnings"
              value={editedUser.earnings}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div style={inputContainerStyle}>
            <label style={labelStyle}>Monthly Earnings:</label>
            <input
              type="number"
              name="monthlyEarnings"
              value={editedUser.monthlyEarnings}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>Monthly Spent:</label>
            <input
              type="number"
              name="monthlySpent"
              value={editedUser.monthlySpent}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>Account Verified?</label>
            <select
              name="isUserActive"
              value={editedUser.isUserActive}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>

          <div style={inputContainerStyle}>
            <label style={labelStyle}>Email Verified?</label>
            <select
              name="emailVerified"
              value={editedUser.emailVerified}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="true">Verified</option>
              <option value="false">Not Verified</option>
            </select>
          </div>

          {isLoading ? (
            <Spinner animation="border" size="sm" variant='primary' />
          ) : (
            <div style={buttonContainerStyle}>
              <button onClick={handleSave} style={saveButtonStyle}>Save</button>
              <button onClick={onClose} style={cancelButtonStyle}>Cancel</button>
            </div>
          )}

        </form>
      </div>
    </div>
  );
};

// Modal overlay style (dimmed background)
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000, // Ensure it's on top of other content
};

// Modal content box style
const modalContentStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '400px', // Increased width for better form layout
  textAlign: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  maxHeight: '80vh', // Limit the height of the modal
  overflowY: 'auto', // Enable scroll if content exceeds height
};

// Input container for consistent spacing
const inputContainerStyle = {
  marginBottom: '15px', // Space between form fields
  textAlign: 'left',
};

// Label style
const labelStyle = {
  fontWeight: 'bold',
  marginBottom: '5px',
  display: 'block',
  color: '#000',
};

// Input field style
const inputStyle = {
  width: '100%',
  padding: '8px',
  marginBottom: '5px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  fontSize: '14px',
};

// Button container style
const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
};

// Save button style
const saveButtonStyle = {
  backgroundColor: '#4CAF50',
  color: 'white',
  padding: '10px 20px',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  width: '48%',
};

const cancelButtonStyle = {
  backgroundColor: '#f44336',
  color: 'white',
  padding: '10px 20px',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  width: '48%',
};

export default EditUserModal;
